

const seasonTraining = (data) => {
    //hacemos un for para mirar todos los jugadores
    const players = data.teams[0].players

    //Keeper->3Reflejos && 2Fuerza
    //Beater->3Fuerza && 2Precision
    //Chaser->3Precision && 1Manejo && 1Reflejos
    //Seeker->4Manejo && 1Reflejos
    //todos 2Resistencia
    //todo ataque y defensa subidas y bajadas
    //maximo maximo 30 puntos de habilidad en worst case (18 años, la habilidad que sube tiene 1 y ha jugado 40 partidos)
    //minimo minimo 1 punto de habilidad en best case (25 años, la habilidad que sube tiene 98 y ha jugado 1 partidos)

    //coeficiente de edad como maximo es 4 y como minimo 1

    //coeficiente de partidos como maximo es 4 y como minimo 1
    for(let i = 0; i < players.length; i++){
        const age = players[i].age
        const fullGames = players[i].stats.gAsKeeper + players[i].stats.gAsBeater + players[i].stats.gAsChaser + players[i].stats.gAsSeeker

        let precision = players[i].skills[0];
        let reflejos = players[i].skills[1];
        let manejo = players[i].skills[2];
        let fuerza = players[i].skills[3];
        let resistencia = players[i].skills[4];

        if(age < 26){
            //sube
            const CE = -((age-26)/2)

            let CP = 1;

            let subidaPrecision = 0
            let subidaReflejos = 0
            let subidaManejo = 0
            let subidaFuerza = 0
            let subidaResistencia = 0

            //comprobamos keeper
            CP = players[i].stats.gAsKeeper
            if(CP > 40) CP = 40;
            if(CP > 0){
                subidaReflejos = trainYoung(reflejos,CE,CP,3)
                subidaFuerza = trainYoung(fuerza,CE,CP,2)
                reflejos += subidaReflejos
                if(reflejos > 99) reflejos = 99
                fuerza += subidaFuerza
                if(fuerza > 99) fuerza = 99
            }

            //beater
            CP = players[i].stats.gAsBeater
            if(CP > 40) CP = 40;
            if(CP > 0){
                subidaFuerza = trainYoung(fuerza,CE,CP,3)
                subidaPrecision = trainYoung(precision,CE,CP,2)
                fuerza += subidaFuerza
                if(fuerza > 99) fuerza = 99
                precision += subidaPrecision
                if(precision > 99) precision = 99
            }

            //chaser
            CP = players[i].stats.gAsChaser
            if(CP > 40) CP = 40;
            if(CP > 0){
                subidaPrecision = trainYoung(precision,CE,CP,3)
                subidaManejo = trainYoung(manejo,CE,CP,1)
                subidaReflejos = trainYoung(reflejos,CE,CP,1)
                precision += subidaPrecision
                if(precision > 99) precision = 99
                manejo += subidaManejo
                if(manejo > 99) manejo = 99
                reflejos += subidaReflejos
                if(reflejos > 99) reflejos = 99
            }

            //seeker
            CP = players[i].stats.gAsSeeker
            if(CP > 40) CP = 40;
            if(CP > 0){
                subidaManejo = trainYoung(manejo,CE,CP,4)
                subidaReflejos = trainYoung(reflejos,CE,CP,1)
                manejo += subidaManejo
                if(manejo > 99) manejo = 99
                reflejos += subidaReflejos
                if(reflejos > 99) reflejos = 99
            }

            CP = players[i].stats.gAsKeeper + players[i].stats.gAsBeater + players[i].stats.gAsChaser + players[i].stats.gAsKeeper
            if(CP > 40) CP = 40;
            if(CP > 0){
                subidaResistencia = trainYoung(resistencia,CE,CP,2)
                resistencia += subidaResistencia
                if(resistencia > 99) resistencia = 99
            }
            
        } else if(age > 29){
            //baja
            const CE = age-29
            let CP = fullGames

            if(CP == 0) CP = 1

            precision -= trainOld(precision,CE,CP)
            if(precision < 1) precision = 1
            reflejos -= trainOld(reflejos,CE,CP)
            if(reflejos < 1) reflejos = 1
            manejo -= trainOld(manejo,CE,CP)
            if(manejo < 1) manejo = 1
            fuerza -= trainOld(fuerza,CE,CP)
            if(fuerza < 1) fuerza = 1
            resistencia -= trainOld(resistencia,CE,CP)
            if(resistencia < 1) resistencia = 1
        }
        data.teams[0].players[i].skills[0] = precision
        data.teams[0].players[i].skills[1] = reflejos
        data.teams[0].players[i].skills[2] = manejo
        data.teams[0].players[i].skills[3] = fuerza
        data.teams[0].players[i].skills[4] = resistencia
    }
    
    return data
}

function trainYoung(skill, CE, CP, CI){
    //CI es coeficiente importancia
    //return ((20*CI) - ((CI/10)*skill)) * ((CE/(4+(CE/2)))) * (CP/(20+(CP/2)))
    return Math.ceil((CI*20) * (CE/(3.5+(skill/50))) * (CP/40) * ((100-skill)/100))
}
function trainOld(skill, CE, CP){
    return Math.ceil(0.5 * (CE/5) * (30/CP) * (skill/40))
}

export default seasonTraining
